export interface CoreLayoutRouteData {
	showSeoFooter?: boolean;
	hideBreadcrumb?: boolean;
}

export const FOOTER_TRANSLATIONS = {
	translations: [
		"footer.social-network.title",
		"footer.sponsorship.title",
		"footer.copyright-desktop",
		"footer.responsible-gaming",
		"footer.licence.title",
	],
};
